<template>
    <div class="exit-intent-survey-modal" ref="exitIntentModal"
        v-bind:class="{ 'exit-intent-survey-modal--open': modalOpen }" @click.self="toggleModal()">
        <div class="exit-intent-survey-modal__content">
            <div class="exit-intent-survey-modal__header-container">
                <div class="exit-intent-survey-modal__header"><b>{{ exitIntentHeaderCopy ||
                    `We noticed you’ve paused your journey.Could you let us know what could make your experience
                        better?`}}</b></div>
                <div class="exit-intent-survey-modal__close" @click="toggleModal()">X
                </div>
            </div>
            <textarea maxlength="100" class="exit-intent-survey-modal__input"
                :placeholder="exitIntentPlaceholderCopy || `Add a comment`" v-model="feedback"></textarea>
            <div class="exit-intent-survey-modal__counter">{{ feedback.length }}/100</div>
            <button class="exit-intent-survey-modal__submit" :disabled="feedback.length === 0"
                @click="sendFeedback()"><b>{{ exitIntentCTACopy || `Send` }}</b></button>
        </div>
    </div>
</template>

<script lang="ts">
import {
    Component, Vue
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { exitIntentSurveyService } from '@/services/ExitIntentSurveyService';
import IRange from '@/models/vehicle/interfaces/range.d';
import MobileCheckService from '@/services/MobileCheckService';
import BrowserService from '@/services/BrowserService';

const VehicleModule = namespace('vehicleModule');
const InitialSettingsModule = namespace('initialSettingsModule');

@Component
export default class ExitIntentSurveyComponent extends Vue {
    @VehicleModule.Getter public currentRange!: IRange;

    private modalOpen: boolean = false;

    private feedback: string = '';

    private alreadyOpened: boolean = false;

    @InitialSettingsModule.Getter public exitIntentSurveyDelay;

    @InitialSettingsModule.Getter public exitIntentHeaderCopy;

    @InitialSettingsModule.Getter public exitIntentPlaceholderCopy;

    @InitialSettingsModule.Getter public exitIntentCTACopy;

    private async getIpAddress(): Promise<string> {
        try {
            const response = await fetch('https://checkip.amazonaws.com/');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const text = await response.text();

            const data = text.trim();
            return data;
        } catch (error) {
            console.error('Error fetching IP:', error);
            return '';
        }
    }

    public async getDetails() {
        const correlationID = this.$store.getters['initialSettingsModule/correlationId'];
        const currentStep = this.$store.getters['enquiryModule/currentStep'];
        const currentManufacturer = this.$store.getters['vehicleModule/currentManufacturer'];
        return {
            correlationId: correlationID,
            dateTime: new Date().toISOString(),
            pageUrl: window.location.href,
            stepId: currentStep,
            manufacturerName: currentManufacturer ? currentManufacturer.manufacturerName : '',
            manufacturerId: currentManufacturer ? currentManufacturer.manufacturerId : '',
            rangeName: this.currentRange ? this.currentRange.rangeName : '',
            rangeId: this.currentRange ? this.currentRange.rangeId : '',
            device: MobileCheckService.isOnMobile === true ? 'Mobile' : 'Desktop',
            browser: BrowserService.getBrowser(),
            userAgent: navigator.userAgent,
            ipAddress: await this.getIpAddress(),
            surveyResponse: this.feedback
        };
    }

    public toggleModal(): void {
        if (!this.alreadyOpened && !this.modalOpen) {
            this.modalOpen = true;
            this.alreadyOpened = true;
        } else if (this.modalOpen) {
            this.modalOpen = false;
            exitIntentSurveyService.stopMonitoring();
        }
    }

    public sendFeedback(): void {
        this.getDetails().then((res) => {
            exitIntentSurveyService.sendSurveyResponse(res);
        });
        this.toggleModal();
    }

    public mounted() {
        exitIntentSurveyService.initialize(this.showModal.bind(this), this.exitIntentSurveyDelay);
        exitIntentSurveyService.startMonitoring();
    }

    private showModal() {
        if (!this.alreadyOpened) {
            this.modalOpen = true;
            this.alreadyOpened = true;
        }
    }
}

</script>
